import React from "react";
import styled from "styled-components";
import { Helmet } from "react-helmet";
import ProjectImage from "../../assets/ProjectCargo.jpg";

const ProjectCargo = () => {
  return (
    <>
      <Helmet>
        <title>Project Cargo | Trans World Shipping</title>
        <meta
          name="description"
          content="Efficient project cargo solutions for your international shipping needs."
        />
        <link
          rel="canonical"
          href="https://transworldshippingcompany.com/services/project-cargo"
        />
      </Helmet>

      <TheProjectCargo>
        <div className="project-hero">
          <img src={ProjectImage} alt="Project Cargo" />
          <div className="hero-overlay"></div>
          <div className="hero-content">
            <h1>Project Cargo</h1>
            <p>45+ years of impressive international track record</p>
          </div>
        </div>

        <div className="project-container">
          <div className="track-record-section">
            <p>
              Our international track record over the past 45 years is
              impressive.
            </p>
          </div>

          <div className="availability-section">
            <p>
              Senior management and their team members are available at the
              Regional Global head offices twenty four hours a day, seven days a
              week, to analyse feasibility and possible options, as well as to
              take on any challenges in the tradition of our reliable
              performance.
            </p>
          </div>

          <div className="operators-section">
            <p>
              We are world-class slot and full charterers and logistics
              operators.
            </p>
          </div>
        </div>
      </TheProjectCargo>
    </>
  );
};

const TheProjectCargo = styled.div`
  width: 100%;
  background: #ffffff;

  .project-hero {
    position: relative;
    width: 100%;
    height: 45vh;
    min-height: 350px;
    overflow: hidden;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }

    .hero-overlay {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: linear-gradient(
        135deg,
        rgba(11, 30, 51, 0.8) 0%,
        rgba(0, 0, 0, 0.5) 100%
      );
    }

    .hero-content {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      text-align: center;
      color: white;
      width: 100%;
      padding: 0 2rem;
      z-index: 1;

      h1 {
        font-size: 3rem;
        font-weight: 700;
        margin-bottom: 1rem;
      }

      p {
        font-size: 1.2rem;
        opacity: 0.9;
      }
    }
  }

  .project-container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 4rem 2rem;
  }

  .track-record-section {
    background: linear-gradient(135deg, #0b1e33 0%, #0a1a2c 100%);
    padding: 2rem;
    border-radius: 12px;
    text-align: center;
    margin-bottom: 1.5rem;

    p {
      color: #d4af37;
      font-size: 1.3rem;
      line-height: 1.7;
      font-weight: 600;
    }
  }

  .availability-section {
    background: #f8f9fa;
    padding: 2rem;
    border-radius: 12px;
    text-align: center;
    margin-bottom: 1.5rem;
    border: 1px solid #e2e8f0;

    p {
      font-size: 1rem;
      color: #4a5568;
      line-height: 1.7;
    }
  }

  .operators-section {
    background: #f8f9fa;
    padding: 2rem;
    border-radius: 12px;
    text-align: center;
    border: 1px solid #d4af37;

    p {
      font-size: 1.1rem;
      color: #0b1e33;
      line-height: 1.7;
      font-weight: 600;
    }
  }

  @media screen and (max-width: 900px) {
    .project-hero {
      height: 40vh;
      min-height: 300px;

      .hero-content h1 {
        font-size: 2.5rem;
      }

      .hero-content p {
        font-size: 1rem;
      }
    }

    .project-container {
      padding: 3rem 1.5rem;
    }

    .track-record-section p {
      font-size: 1.1rem;
    }
  }

  @media screen and (max-width: 768px) {
    .project-hero {
      min-height: 250px;

      .hero-content h1 {
        font-size: 2rem;
      }
    }

    .project-container {
      padding: 2rem 1rem;
    }

    .track-record-section,
    .availability-section,
    .operators-section {
      padding: 1.5rem;
    }

    .track-record-section p {
      font-size: 1rem;
    }

    .operators-section p {
      font-size: 1rem;
    }
  }

  @media screen and (max-width: 600px) {
    .project-hero .hero-content h1 {
      font-size: 1.6rem;
    }

    .track-record-section p,
    .availability-section p,
    .operators-section p {
      font-size: 0.95rem;
    }
  }

  @media screen and (max-width: 480px) {
    .project-hero .hero-content h1 {
      font-size: 1.3rem;
    }

    .project-hero .hero-content p {
      font-size: 0.9rem;
    }

    .track-record-section,
    .availability-section,
    .operators-section {
      padding: 1rem;
    }
  }
`;

export default ProjectCargo;
